import clsx from 'clsx';
import React from 'react';
import Button from '../Button';
import WarningIcon from '../../assets/icons/warning-icon.svg?react';

interface OSHANotAvailableProps {
  otherClasses?: string;
}

const OSHANotAvailable: React.FC<OSHANotAvailableProps> = ({
  otherClasses,
}) => {
  const noDepartmentClasses = clsx(
    otherClasses,
    'bg-light-neutral-tones-text/30 absolute flex flex-col left-0 top-0 h-screen w-full items-center justify-center backdrop-blur-xs md:px-0 px-4',
  );

  return (
    <div className={noDepartmentClasses} data-testid="no-department">
      <div className="flex max-w-3xl flex-col items-center text-center">
        <WarningIcon className="[&>g>path]:fill-brand-posh-pink h-12 w-12 md:h-85 md:w-85" />
        <h3 className="text-brand-posh-pink">OSHA Reporting Not Available</h3>
        <p className="text-neutral-tones-text font-inter-variable mt-4 text-lg font-semibold">
          OSHA reporting is only available between January 2nd and March 2nd.
          The current date is either before January 2nd or after March 2nd, so
          reporting is currently unavailable.
        </p>
        <Button
          href="/dashboard"
          size="small"
          otherClasses="mt-4 bg-brand-posh-pink hover:border-brand-posh-pink hover:text-brand-posh-pink"
        >
          Back To Dashboard
        </Button>
      </div>
    </div>
  );
};

export default OSHANotAvailable;
